// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rowActionDropdown___aTE5o{justify-content:center}\n", "",{"version":3,"sources":["webpack://./src/components/Table/RowActionDropdown/style.css"],"names":[],"mappings":"AAAA,2BACI,sBAAA","sourcesContent":[".rowActionDropdown {\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rowActionDropdown": "rowActionDropdown___aTE5o"
};
export default ___CSS_LOADER_EXPORT___;
